import { Box, CircularProgress, Typography } from '@mui/material';
import { DisplayParams } from '../types/classes/DisplayParams';
import Filters from './Filters';
import IssueCardCollection from './IssueCardCollection';
import { IDisplayParams } from '../types/interfaces/IDisplayParams';
import { useState } from 'react';
import { useCphDataContext } from '../hooks/useCphDataContext';

export default function FiltersAndIssueCards({ onViewIssue }: { onViewIssue: () => void }) {
    const [displayParams, setDisplayParams] = useState<IDisplayParams | undefined>(new DisplayParams());
    const { filtersHydrated } = useCphDataContext();

    return (
        <>
            <Box sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'flex-start',
                alignContent: 'flex-start',
                padding: 6
            }}>
                <Box sx={{ width: 200 }}>
                    <Filters
                        displayParams={displayParams as DisplayParams}
                        onDisplayChange={setDisplayParams} />
                </Box>
                <Box sx={{ display: 'flex', width: { xs: "90%", md: "70%", lg: "75%" } }}>
                    {filtersHydrated ? (
                        <IssueCardCollection
                            displayParams={displayParams as DisplayParams}
                            onDisplayChange={setDisplayParams}
                            onViewIssue={onViewIssue}
                        />
                    ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 3 }}>
                            <CircularProgress size={20} />
                            <Typography variant="body2">Restoring filters...</Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </>
    );
}